import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useStores } from "@/store";
import { getQuery } from "@/service/http";

export default function DealPrivacy(props) {
  const { CommonStore } = useStores();
  const { t } = useTranslation();
  const [privacy, setPrivacy] = useState({});
  const { regionId, region_id, region } = getQuery();
  useEffect(() => {
    CommonStore.getFooterDetail(region || regionId || region_id).then(
      (data) => {
        setPrivacy(data);
      }
    );
  }, []);
  if (!privacy.privacy_policy) return null;
  return (
    <div
      className="buydeal-cashier-terms"
      dangerouslySetInnerHTML={{
        __html: t("walkin.terms", {
          privacyUrl: privacy.privacy_policy + "?embed_mode=true",
          termsAndConditions: privacy.terms_and_conditions + "?embed_mode=true",
          buttonText: props.buttonText || t('PAYMENT.Pay now')
        }),
      }}
    ></div>
  );
}
